/**
 * The join code, big enough to read out loud, and one tap to copy.
 *
 * Reading a code aloud is the normal way a session gets its second player, so the code is the
 * largest thing on the screen and the copy button is beside it rather than behind a menu. Copying
 * can fail without a secure context or a permission, and it says so on the button rather than
 * silently doing nothing, because a player who thinks they copied a code pastes an old one.
 */

import {
  LOBBY_CODE_COPIED,
  LOBBY_CODE_COPY,
  LOBBY_CODE_COPY_FAILED,
  LOBBY_CODE_LABEL,
} from '@/text/lobbyText';
import { el, setText } from '@/ui/dom';

export interface LobbyCodePanel {
  readonly root: HTMLElement;
  show(code: string): void;
}

export function createLobbyCodePanel(): LobbyCodePanel {
  const root = el('div', 'lobby-code');
  const value = el('span', 'lobby-code-value', '');
  const copy = el('button', 'lobby-copy', LOBBY_CODE_COPY);
  copy.type = 'button';

  copy.addEventListener('click', () => {
    void navigator.clipboard.writeText(value.textContent).then(
      () => {
        setText(copy, LOBBY_CODE_COPIED);
      },
      () => {
        setText(copy, LOBBY_CODE_COPY_FAILED);
      },
    );
  });

  root.append(el('span', 'lobby-code-label', LOBBY_CODE_LABEL), value, copy);

  return {
    root,
    show(code: string): void {
      if (value.textContent === code) return;
      setText(value, code);
      setText(copy, LOBBY_CODE_COPY);
    },
  };
}
